import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Web\Studio\ReleaseChannelController::update
* @see Http/Controllers/Web/Studio/ReleaseChannelController.php:21
* @route '/studio/{team}/scenarios/{scenario}/release-channels/{releaseChannel}'
*/
export const update = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, releaseChannel: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, releaseChannel: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(args, options),
    method: 'patch',
})

update.definition = {
    methods: ["patch"],
    url: '/studio/{team}/scenarios/{scenario}/release-channels/{releaseChannel}',
} satisfies RouteDefinition<["patch"]>

/**
* @see \App\Http\Controllers\Web\Studio\ReleaseChannelController::update
* @see Http/Controllers/Web/Studio/ReleaseChannelController.php:21
* @route '/studio/{team}/scenarios/{scenario}/release-channels/{releaseChannel}'
*/
update.url = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, releaseChannel: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, releaseChannel: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            team: args[0],
            scenario: args[1],
            releaseChannel: args[2],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        team: typeof args.team === 'object'
        ? args.team.slug
        : args.team,
        scenario: typeof args.scenario === 'object'
        ? args.scenario.id
        : args.scenario,
        releaseChannel: typeof args.releaseChannel === 'object'
        ? args.releaseChannel.id
        : args.releaseChannel,
    }

    return update.definition.url
            .replace('{team}', parsedArgs.team.toString())
            .replace('{scenario}', parsedArgs.scenario.toString())
            .replace('{releaseChannel}', parsedArgs.releaseChannel.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Web\Studio\ReleaseChannelController::update
* @see Http/Controllers/Web/Studio/ReleaseChannelController.php:21
* @route '/studio/{team}/scenarios/{scenario}/release-channels/{releaseChannel}'
*/
update.patch = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, releaseChannel: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, releaseChannel: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(args, options),
    method: 'patch',
})

/**
* @see \App\Http\Controllers\Web\Studio\ReleaseChannelController::update
* @see Http/Controllers/Web/Studio/ReleaseChannelController.php:21
* @route '/studio/{team}/scenarios/{scenario}/release-channels/{releaseChannel}'
*/
const updateForm = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, releaseChannel: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, releaseChannel: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Web\Studio\ReleaseChannelController::update
* @see Http/Controllers/Web/Studio/ReleaseChannelController.php:21
* @route '/studio/{team}/scenarios/{scenario}/release-channels/{releaseChannel}'
*/
updateForm.patch = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, releaseChannel: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, releaseChannel: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

update.form = updateForm

/**
* @see \App\Http\Controllers\Web\Studio\ReleaseChannelController::destroy
* @see Http/Controllers/Web/Studio/ReleaseChannelController.php:36
* @route '/studio/{team}/scenarios/{scenario}/release-channels/{releaseChannel}'
*/
export const destroy = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, releaseChannel: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, releaseChannel: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/studio/{team}/scenarios/{scenario}/release-channels/{releaseChannel}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Web\Studio\ReleaseChannelController::destroy
* @see Http/Controllers/Web/Studio/ReleaseChannelController.php:36
* @route '/studio/{team}/scenarios/{scenario}/release-channels/{releaseChannel}'
*/
destroy.url = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, releaseChannel: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, releaseChannel: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            team: args[0],
            scenario: args[1],
            releaseChannel: args[2],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        team: typeof args.team === 'object'
        ? args.team.slug
        : args.team,
        scenario: typeof args.scenario === 'object'
        ? args.scenario.id
        : args.scenario,
        releaseChannel: typeof args.releaseChannel === 'object'
        ? args.releaseChannel.id
        : args.releaseChannel,
    }

    return destroy.definition.url
            .replace('{team}', parsedArgs.team.toString())
            .replace('{scenario}', parsedArgs.scenario.toString())
            .replace('{releaseChannel}', parsedArgs.releaseChannel.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Web\Studio\ReleaseChannelController::destroy
* @see Http/Controllers/Web/Studio/ReleaseChannelController.php:36
* @route '/studio/{team}/scenarios/{scenario}/release-channels/{releaseChannel}'
*/
destroy.delete = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, releaseChannel: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, releaseChannel: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Web\Studio\ReleaseChannelController::destroy
* @see Http/Controllers/Web/Studio/ReleaseChannelController.php:36
* @route '/studio/{team}/scenarios/{scenario}/release-channels/{releaseChannel}'
*/
const destroyForm = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, releaseChannel: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, releaseChannel: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Web\Studio\ReleaseChannelController::destroy
* @see Http/Controllers/Web/Studio/ReleaseChannelController.php:36
* @route '/studio/{team}/scenarios/{scenario}/release-channels/{releaseChannel}'
*/
destroyForm.delete = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, releaseChannel: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, releaseChannel: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

const releaseChannels = {
    update: Object.assign(update, update),
    destroy: Object.assign(destroy, destroy),
}

export default releaseChannels